/* global FWP */

export default {
    init() {
        this.priceSliderEl = document.getElementById('filter-price')
        this.productFilter = $('.product-filter')
        this.productsContainer = $('#products-container')

        if ($('#filter-price').length) {
            this.priceSlider()
        }

        if (this.productFilter.length) {
            this.initFilters()
        }

        this.listenForFacetLoaded(); 

        this.initEventListeners()

    },
    listenForFacetLoaded() {
        // 1. Listener (catches it if triggered later)
        $(document).on('facetwp-loaded', this.updateResetButton.bind(this));
    
        // 2. Already loaded? Run it now just in case
        if (typeof FWP !== 'undefined' && typeof FWP.loaded !== 'undefined' && FWP.loaded === true) {
          this.updateResetButton();
        }
      },
    
      updateResetButton() {
    
        const qs = FWP.buildQueryString();
        if (qs === '') {
          $('.product-filter__reset-cta').hide();
        } else {
          $('.product-filter__reset-cta').show();
        }
      },

    initEventListeners() {

        // Mobile button for toggling filter menu
        $('.filter-toggle').click( () => {
            $('body').toggleClass('filter-open')
            $('.offcanvas-overlay').fadeToggle()
        })

        // Extra click function for offcanvas overlay and close button to close filter menu
        $('.offcanvas-overlay, .product-filter__close').click( () => {
            this.hideFilterOverlay()
        })

        // Prevent default form submission of order by
        $(document).on('submit', '.woocommerce-ordering', (e) => {
            e.preventDefault()
        })

        // When pagination items are clicked
        $(document).on('click', '.facetwp-page', (e) => {
            e.preventDefault()
            $('html, body').animate({
                scrollTop: $('.product-listing-container').offset().top,
            }, 1000)
        })

    },
    hideFilterOverlay() {

        $('body').removeClass('filter-open')
        $('.offcanvas-overlay').fadeOut()

    },
    initFilters() {
        // Detect when search input/query has been changed and reset all FacetWP filters.
        document.addEventListener('facetwp-refresh', function() {

            // Check if any facets are in use before trying to go into the dataset.
            if (null !== FWP.active_facet) {

                if ( FWP.active_facet.nodes[0].dataset.name === 'search' ) {
                    $.each(FWP.facets, function(name, val) {
                        if (val.length > 0 && 'search' != name ) {
                            FWP.facets[name] = [];
                        }
                    })
                }
            }
        
        });


        // Add class to checked and un-checked facet options on load and after user interaction.
        document.addEventListener('facetwp-loaded', function() {
            // Give the facet a class name if any of its choices are checked.
            var facet_name = 'colour';

            // Check if facet_name exists inside FWP.facets
            if ( FWP.facets[facet_name] ) {

                var in_use = FWP.facets[facet_name].length ? true : false;
                $('.facetwp-facet-' + facet_name).toggleClass('has-checked', in_use);

                // If at-least one of the facet options are checked, add a class to the rest.
                if( in_use ) {
                    var parent = $('.facetwp-facet-' + facet_name);
                    parent.find('.facetwp-color-wrap').each(function() {
                        var $this = $(this);
                        
                        // Check if div has "checked" class. If not, add an "inactive" class.
                        if (!$(this).hasClass('checked')) {
                            $this.addClass('inactive');
                        }
                    });
                }

            }

            // Loop through each .card in .accordion
            $('.accordion .card .facetwp-facet').each(function() {

                const facetId = $(this).data('name');

                // Check if div is empty, if so, hide accordion div.
                if ($(this).html() == '') {

                    // Find previous .card div and remove.
                    $('#card__' + facetId).hide();

                    console.log('Removed empty product filter - ' + facetId);
                } else {

                    // If div not empty, show accordion div.
                    $('#card__' + facetId).show();
                }

            });

            // Remove the overlay once FacetWP has loaded and products displayed.
            $(this.productsContainer).removeClass('products-container--loading');

            // Hide mobile sidebar when a filter option has been selected.
            this.hideFilterOverlay();

        }.bind(this));

        document.addEventListener('facetwp-refresh', function() {
            $(this.productsContainer).addClass('products-container--loading');
        }.bind(this));

        // When a colour "label" is clicked, click the div above which is the colour option trigger.
        $(document).on('click', '.facetwp-color-label', function() {
            $(this).prev().trigger('click');
        });

    },
    checkOrderByType(orderVal) {

        if ( orderVal == 'date' ) {
            return 'date';
        } else if ( orderVal == 'price' ) {
            return 'price';
        } else if ( orderVal == 'relevance' ) {
            return 'relevance';
        } else if ( orderVal == 'custom_order') {
          return 'custom_order';
        }

        return 'price';

    },
    checkOrderType(orderVal) {

        if ( orderVal == 'date' ) {
            return 'DESC';
        } else if ( orderVal == 'price-desc' ) {
            return 'DESC';
        } else if ( orderVal == 'relevance' ) {
            return 'DESC';
        } else if ( orderVal == 'custom_order' ) {
          return 'DESC';
        }

        return 'ASC';

    },
    setSelectOption(filters) {

        // Finds out what the active sort by item is
        const ordering = $('.orderby')
        const order = filters.order
        const orderBy = filters.orderby
        const activeItem = this.checkActiveSortBy(order, orderBy)

        ordering.val(activeItem)

        // Grab all url parameters.
        var urlParams = new URLSearchParams(window.location.search);

        // Check if an <option> exists for relevance.
        var optionExists = $('.orderby option[value=\'relevance\']').length;

        // Check for keyword parameter in URL and relevance option doesn't already exist.
        if( urlParams.has('keyword') && optionExists !== 1 ) {

            // Add "Sort by Relevance" option only when a search term is present.
            $('.orderby').append($('<option>', {
                value: 'relevance',
                text: 'Sort by relevance',
                id: 'orderby-relevance',
            }));

        } else if ( optionExists == 1 && urlParams.has('keyword') == false ) {

            $('.orderby option[value=\'relevance\']').each(function() {
                $(this).remove();
            });

        }

        // Check url parameter value. If relevance, make that option in <select> field the selected option.
        if( urlParams.get('orderby') == 'relevance' ) {

            $('#orderby-relevance').attr('selected', 'selected');

        }


    },
    checkActiveSortBy(order, orderBy) {

        if( order == 'DESC' && orderBy == 'price' ) {

            const activeItem = orderBy + '-desc';

            return activeItem;

        } else if ( orderBy == 'relevance' ) {

            const activeItem = orderBy;

            return activeItem;

        } else {

            const activeItem = orderBy;

            return activeItem;
        }

    },
};
